/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import {
    REQUEST_FLEETS,
    RECEIVE_FLEETS,
    REQUEST_FLEET,
    RECEIVE_FLEET,
    RECEIVE_FLEET_ERROR,
    RECEIVE_SUB_FLEETS,
    REQUEST_SUB_FLEETS,
    REQUEST_ASSETS,
    RECEIVE_ASSETS,
    RECEIVE_ASSETS_FOR_THE_FIRST_TIME,
    CLEAR_STATE
} from "./FleetActions";

const initialState = {
    fleets: [],
    details: null,
    subfleets: [],
    assets: [],
    loading: false,
    subResourceLoading: false,
    error: null,
}

export const fleet = (state = initialState, action) => {
    switch (action.type) {
        case REQUEST_FLEET:
        case REQUEST_FLEETS:
            return {
                ...state,
                loading: true,
            }
        case RECEIVE_FLEETS:
            return {
                ...state,
                loading: false,
                fleets: action.fleets,
            }
        case RECEIVE_FLEET:
            return {
                ...state,
                loading: false,
                details: action.fleet,
            }
        case REQUEST_SUB_FLEETS:
        case REQUEST_ASSETS:
            return {
                ...state,
                subResourceLoading: true,
            }
        case RECEIVE_SUB_FLEETS:
            return {
                ...state,
                subResourceLoading: false,
                subfleets: action.fleets,
            }
        case RECEIVE_ASSETS:
            return {
                ...state,
                subResourceLoading: false,
                assets: action.assets,
            }
        case RECEIVE_ASSETS_FOR_THE_FIRST_TIME:
            return {
                ...state,
                subResourceLoading: false,
                assets: action.assets,
                details: {
                    faultsCount: action.faultCounts,
                    assetCount: action.assetCount,
                    assetsFaultStatesCount: action.assetsFaultStatesCount,
                },
            }
        case RECEIVE_FLEET_ERROR:
            return {
                ...state,
                loading: false,
                error: action.error.errorKey,
            }
        case CLEAR_STATE:
            return initialState
        default:
            return state
    }
}